import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import {
  FindManyFxRates,
  FindOne,
  FxRate,
  PAYMENT_CURRENCY,
  PaginateResult,
  Setting,
} from '@univacity/shared/types';
import { BehaviorSubject, Observable } from 'rxjs';
import { Configuration } from '../config';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class FxRateService {
  private baseUrl: string;
  baseCurrency: string;
  base: string;
  rates: Record<string, string | number>;
  to: string;
  baseCurrency$: BehaviorSubject<string> = new BehaviorSubject(
    PAYMENT_CURRENCY.EUR as string
  );

  private http: HttpClient = inject(HttpClient);
  private config: Configuration = inject(Configuration);
  private storage: StorageService = inject(StorageService);

  constructor() {
    this.baseUrl = this.config.apiMainUrl + '/payment/rate';
    const rateString = this.storage.getItem(Setting.fxRate);
    const rate: FxRate = rateString && JSON.parse(rateString);
    if (rate) this.updateFx(rate);
  }

  find(query: FindManyFxRates = {}): Observable<PaginateResult<FxRate>> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<FxRate>>(this.baseUrl, { params });
  }

  findOne(id: string, query: FindOne = {}): Observable<FxRate> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<FxRate>(`${this.baseUrl}/${id}`, { params });
  }

  update(code: string) {
    this.findOne(code).subscribe((c) => {
      this.storage.setItem(Setting.currency, code);
      this.storage.setItem(Setting.fxRate, JSON.stringify(c));
      this.updateFx(c);
    });
  }

  convert(prop: { amount: number; from: string; to?: string }): number {
    const toRate = +this.rates[prop.to || this.base];
    const fromRate = +this.rates[prop.from];
    if (prop.to?.toLocaleUpperCase() === 'NGN')
      return Math.ceil(((prop.amount / fromRate) * toRate) / 1000) * 1000;

    return (prop.amount / fromRate) * toRate;
  }

  private updateFx(c: FxRate) {
    this.base = c.base;
    this.rates = c.rates;
    this.baseCurrency$.next(c.base);
    this.baseCurrency = c.base;
  }
}
